import React from "react";

const Pills = ({
	options = [],
	value = [],
	onChange,
	className = "",
	ariaLabel = "Selector",
}) => {
	const selectedValues = Array.isArray(value) ? value : [];

	const isSelected = (optionValue) => selectedValues.includes(optionValue);

	const handleClick = (optionValue) => {
		if (!onChange) return;

		const nextValues = isSelected(optionValue)
			? selectedValues.filter((item) => item !== optionValue)
			: [...selectedValues, optionValue];

		onChange(nextValues);
	};

	return (
		<div className={`pills ${className}`} role="group" aria-label={ariaLabel}>
			{options.map((option) => (
				<button
					key={option.value}
					type="button"
					className={`pills__item ${isSelected(option.value) ? "is-active" : ""}`}
					onClick={() => handleClick(option.value)}
				>
					{option.label}
				</button>
			))}
		</div>
	);
};

export default Pills;
